const OpenBankingPayment = () =>
  import(
    /* webpackChunkName: "financial-payment-open-banking-payment" */ '@/pages/financial/payment/open-banking/index.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-payment-open-banking-payment" */ '@/pages/financial/payment/open-banking/edit.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-payment-open-banking-payment" */ '@/pages/financial/payment/open-banking/create.vue'
  )

export default {
  path: 'open-banking',
  meta: {
    label: 'openBankingPayment',
    auth: 'openBanking'
  },
  component: {
    name: 'OpenBankingPayment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialPaymentOpenBankingReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: OpenBankingPayment
    },
    {
      name: 'FinancialPaymentCreateOpenBanking',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialPaymentEditOpenBanking',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
